import { useState, useCallback } from 'react';

interface ConfirmDialogState {
    isOpen: boolean;
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    isDestructive: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export const useConfirmDialog = () => {
    const [dialogState, setDialogState] = useState<ConfirmDialogState>({
        isOpen: false,
        title: '',
        message: '',
        confirmText: 'Confirm',
        cancelText: 'Cancel',
        isDestructive: false,
        onConfirm: () => {},
        onCancel: () => {}
    });

    const showConfirm = useCallback((options: {
        title: string;
        message: string;
        confirmText?: string;
        cancelText?: string;
        isDestructive?: boolean;
    }) => {
        return new Promise<boolean>((resolve) => {
            setDialogState({
                isOpen: true,
                title: options.title,
                message: options.message,
                confirmText: options.confirmText || 'Confirm',
                cancelText: options.cancelText || 'Cancel',
                isDestructive: options.isDestructive || false,
                onConfirm: () => {
                    setDialogState(prev => ({ ...prev, isOpen: false }));
                    resolve(true);
                },
                onCancel: () => {
                    setDialogState(prev => ({ ...prev, isOpen: false }));
                    resolve(false);
                }
            });
        });
    }, []);

    const hideDialog = useCallback(() => {
        setDialogState(prev => ({ ...prev, isOpen: false }));
    }, []);

    return {
        dialogState,
        showConfirm,
        hideDialog
    };
}; 